// Theme registry — each theme defines its visual identity
export const themes = [
  {
    id: 'arcade',
    name: 'Arcade',
    icon: '🎰',
    pro: false,
    price: 0,
  },
  {
    id: 'classic',
    name: 'Classic',
    icon: '♠️',
    pro: false,
    price: 0,
  },
  {
    id: 'dark',
    name: 'Dark Mode',
    icon: '🌙',
    pro: true,
    price: 1,
  },
  {
    id: 'neon',
    name: 'Neon',
    icon: '💜',
    pro: true,
    price: 1,
  },
  {
    id: 'sakura',
    name: 'Sakura',
    icon: '🌸',
    pro: true,
    price: 1,
  },
  {
    id: 'comic',
    name: 'Comic Book',
    icon: '💥',
    pro: false,
    price: 0,
  },
];

export function getTheme(id) {
  return themes.find(t => t.id === id) || themes[0];
}

export function isThemeUnlocked(themeId, isPro, themePurchases = []) {
  const theme = getTheme(themeId);
  if (!theme.pro) return true;
  if (isPro) return true;
  return themePurchases.includes(themeId);
}
